import React from "react";
import { SPOILER_TYPE, TIPTAP_FIGURE_TYPE, VIDEO_TYPE } from "./../ricos-content";
import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID
} from "./../editor-common";
import { getVisibleOnlyOnDesktopResolver } from "./../plugin-commons";
import {
  AlignmentPanel,
  DeleteButton,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel
} from "./../toolbars-ui";
import { VIDEO_BUTTONS, videoModals } from "./constants";
import { InsertModal } from "./modals/InsertModal";
import { SettingsModal } from "./modals/SettingsModal";
const getToolbarButtons = (config, services) => {
  const {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  } = config || {};
  const {
    modals,
    context: { isMobile }
  } = services;
  const modalBaseProps = {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  };
  const shouldShowSpoiler = () => {
    const spoilerPlugin = services.plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
    return spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(VIDEO_TYPE));
  };
  const settingsVisibilityResolver = {
    id: "IS_VIDEO_SETTINGS_BUTTON_VISIBLE",
    resolve: (content) => {
      if (Array.isArray(content) && content.length > 0) {
        const isCustomVideo = !!content.find((node) => node?.type?.name === Node_Type.VIDEO)?.attrs?.video?.src?.id;
        return shouldShowSpoiler() || isCustomVideo;
      }
      return false;
    }
  };
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT", "FULL_WIDTH"]
        }),
        id: VIDEO_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: VIDEO_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: VIDEO_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: VIDEO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        id: videoModals.settings,
        Component: SettingsModal
      },
      attributes: {
        visible: settingsVisibilityResolver
      },
      command: ({ isMobile: isMobile2, attributes: { selectedNode } }) => {
        modals?.openRegisteredModal(videoModals.settings, {
          componentProps: {
            nodeId: selectedNode.attrs.id
          },
          positioning: { placement: "right" },
          layout: isMobile2 ? "fullscreen" : "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: settingsVisibilityResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(InsertModal, { modalId: videoModals.replace }),
        id: videoModals.replace
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const {
          video: { src },
          id
        } = selectedNode.attrs;
        const videoSrc = src.url ? { url: src.url } : src.id ? { id: src.id } : {};
        if (modals?.isModalOpen(videoModals.replace)) {
          modals.closeModal(videoModals.replace);
        } else {
          modals?.openRegisteredModal(videoModals.replace, {
            componentProps: {
              componentData: { video: { src: videoSrc } },
              nodeId: id,
              ...modalBaseProps
            },
            positioning: { placement: "bottom", referenceElement },
            layout: isMobile2 ? "fullscreen" : "popover",
            noPadding: true
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      renderer: (toolbarItem) => {
        return /* @__PURE__ */ React.createElement(DeleteButton, { toolbarItem });
      },
      command: (data) => {
        const figures = data.editorCommands.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find((f) => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });
        if (selectedFigure) {
          data.editorCommands.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      }
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
